import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B07InvoicePage } from '../b07-invoice/b07-invoice';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { IonicSelectableComponent } from 'ionic-selectable';

/**
 * Generated class for the B07bInvoiceAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface Port {
   id: number;
   name: string;
}

interface corpInfo{
  CORP_ID: number;
  CORP_NAME: string;
}

interface cardInfo{
  CARD_ID: number;
  CARD_NO: number;
  CREDIT_LIMIT: number;
  BALANCE: number;
  CREDIT_USED: number;
}

@IonicPage()
@Component({
  selector: 'page-b07b-invoice-add',
  templateUrl: 'b07b-invoice-add.html',
})
export class B07bInvoiceAddPage {
  ports: Port[] = [];
  port: Port;

  private todo : FormGroup;
  corpArr: corpInfo[] = [];
  corpItems: corpInfo[] = [];
  tempCardArr: cardInfo[] = [];
  cardArr: cardInfo[] = [];
  cardItems: cardInfo[] = [];
  loading: any;
  Status: any;
  Date: any;
  public errorMessage1: any = "";
  public errorMessage2: any = "";
  public errorMessage3: any = "";
  USER_ID: any;
  USERNAME: any;
  SERVERDATE: any;
  SERVERDATE_START: any;
  subTotal: any;
  tax:any = 0 ;
  taxTotal: any;
  grandTotal: any;
  compileCorp: any;
  DATA_Array = [];
  INV_LINE_Array = [];
  count_tax:any = 0;
  invoiceLineData = { /* INVOICE_LINE_ID:'', */ DATETIME:'', 
                      TOTAL_CARD_USED:'', 
                      /* INVOICE_ID:'', */ CARD_ID:0, USED_CREDIT:0,
  }

  invoiceData = { /* INVOICE_ID:'', */ DATETIME:'', 
                  GRANDTOTAL:'', REMARKS:'',  SUB_TOTAL:'', TAX:'', FINALIZED_FLG:'', 
                  INV_CORP_ID:'', ACTION_BY:'',
  }
  ISSUE_SERVERDATE:any;
  last_invoice_date: any;
  totalCard: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController) {

               

    this.todo = this.formBuilder.group({
      remark: [''],
      corporate: ['', Validators.required],
      transdateFrom: ['', Validators.required],
      transdateTo: ['', Validators.required],
    });
    
    this.USERNAME = sessionStorage.getItem('username');
    this.USER_ID = sessionStorage.getItem('userid');

    this.showLoader();

    this.serviceapi.serverdatetime().then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        this.Date = result["Date"];
        this.ISSUE_SERVERDATE = this.Date;
       
      }
      else {
        this.errorMessage1 = this.serviceapi.displayErrorMessage(this.Status);
      }

      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];
    
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");

      this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.corpArr = Records;
          this.corpItems = this.corpArr;
          console.log(this.corpItems);
          //this.ports = [];
          let k=0;
          for(k=0;k<(this.corpItems).length;k++)
          {
            let z = {
              id:1,
              name:""
            }
            z.id = this.corpItems[k].CORP_ID;
            z.name = this.corpItems[k].CORP_NAME;
            console.log(z);
            (this.ports).push(z);
          }
          console.log(this.ports);
          /*this.ports = [
            { id: 1, name: 'Tokai' },
            { id: 2, name: 'Vladivostok' },
            { id: 3, name: 'Navlakhi' }
          ];*/
        }
        else {
          this.errorMessage1 = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage1 = "Loading Error. Please try again.";
        this.loading.dismiss();
      });

    }, (err) => {
      this.errorMessage1 = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }
portChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('port:', event.value);
    this.invoiceData.INV_CORP_ID = event.value["id"];
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad B07bInvoiceAddPage');
  }

  compile(){

  }
   getFlooredFixed(v, d) {
    return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
   }
  onSelectChange(){
    this.tempCardArr=[];
    this.cardArr=[];        //clear array
    this.errorMessage2='';
    this.subTotal=0;
    this.taxTotal=0;
    this.grandTotal=0;
    this.INV_LINE_Array=[];
    //this.last_invoice_date='';

    let tbl = ["INVOICE"];
    let column = ["INV_CORP_ID"];
    let value = [this.invoiceData.INV_CORP_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"INVOICE","1","1").then((result) => {      //search last invoice
      this.Status = result["Message"];

      if (this.Status == "1"){
        let Records = result["Records"];
        let rxdata = result["RXData"];
        console.log(Records);
        //Disable Last invoice CHeck because want to get start and end date
        /*let f_found= 0;
        for(let y=(rxdata); y>0; y--)
        {
          if (f_found == 0){
            if (Records[y-1].FINALIZED_FLG != 'Void'){
              f_found = 1;
              this.last_invoice_date = Records[y-1].ISSUE_DATETIME;
            }
          }
        }*/
          

        //search corporate card
        let tbl = ["CARD"];
        let column = ["CORP_ID"];
        let value = [this.invoiceData.INV_CORP_ID];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
            
          this.Status = result["Message"];
          if (this.Status == "1"){
            
            let Records = result["Records"];
            let rxdata = result["RXData"];
            this.totalCard = result["RXData"];          //total card under corporate

    /*         for(let i=0;i<rxdata;i++)
            {
              Records[i].CREDIT_USED = Records[i].CREDIT_LIMIT - Records[i].BALANCE;  //calculate credit used
              this.cardArr.push(Records[i]);
              this.subTotal = this.subTotal + Records[i].CREDIT_USED;                 //accumulate 

              this.invoiceLineData.DATETIME = this.SERVERDATE;
              this.invoiceLineData.TOTAL_CARD_USED = rxdata;
              this.invoiceLineData.CARD_ID = Records[i].CARD_ID;
              this.invoiceLineData.USED_CREDIT = Records[i].CREDIT_USED;
              console.log(this.invoiceLineData.USED_CREDIT);
              this.INVOICELINE_JSON(this.invoiceLineData.TOTAL_CARD_USED, this.invoiceLineData.CARD_ID, this.invoiceLineData.USED_CREDIT);
            } */

            this.tempCardArr = Records;
            for(let i=0; i<rxdata; i++)
            {
              this.tempCardArr[i].CREDIT_USED = 0;
             
              //find payment record for the card
              let tbl = ["PAYMENT","PAYMENT","SO"];
              //Temporary Disable
              //let column = ["CORP_CARD_ID","PAYMENT_TYPE_ID","SO_STATUS_ID"];
              //let value = [this.tempCardArr[i].CARD_ID, "3", "1"];
              
              let column = ["CORP_CARD_ID","PAYMENT_TYPE_ID","SO_STATUS_ID"];
              let value = [this.tempCardArr[i].CARD_ID, "3", "1"];
              let tblkey = ["SO_ID"];
              let fktbl = ["SO"];
              let fkkey = ["SO_ID"];
          
              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
              var date = new Date(this.SERVERDATE);
              date.setDate(date.getDate());
              var y = date.getFullYear(),
              m = date.getMonth() + 1, // january is month 0 in javascript
              d = date.getDate();
              var pad = function(val) { var str = val.toString(); return (str.length < 2) ? "0" + str : str};
              var dateString = [y, pad(m), pad(d)].join("-");
                // Add a day because ended at selected date + 00:00:00 which will get value on the day as well
              //DATA.DATE = dateString;
              let rangeitem = this.serviceapi.range(this.last_invoice_date,dateString,"DATETIME","PAYMENT");
              let mydata = Object.assign(jsonitem,rangeitem);
              let json_data = this.serviceapi.json_readdata_range(mydata,"1");
              console.log("MOI"+json_data);
              this.serviceapi.readdata(json_data,"PAYMENT","1","1").then((result) => {
                this.Status = result["Message"];
                console.log(result);
                if (this.Status == "1"){
                  
                  let Records = result["Records"];
                  let rxdata1 = result["RXData"];
                  console.log("WHY"+rxdata1);
                 
                  
                  

                  for(let x=0; x<rxdata1; x++){
                    console.log(this.last_invoice_date);
                    
                    

                    
                    if (this.last_invoice_date != '') {
                      
                      if (Records[x].DATETIME >= this.last_invoice_date){
                        console.log("Date bigger!!!")
                        //console.log(this.tempCardArr[i].CREDIT_USED, Records[x].AMOUNT_TENDER)
                        //let abc = this.getFlooredFixed((this.tempCardArr[i].CREDIT_USED).toString(),2);
                        //console.log(abc)
                        //this.tempCardArr[i].CREDIT_USED = parseFloat(abc) +parseFloat(this.getFlooredFixed(Records[x].AMOUNT_TENDER,2));
                        console.log(this.tempCardArr[i].CREDIT_USED, Records[x].AMOUNT_TENDER)
                        let abc = this.tempCardArr[i].CREDIT_USED.toString();
                        console.log(abc)
                        this.tempCardArr[i].CREDIT_USED = parseFloat(abc) +parseFloat(Records[x].AMOUNT_TENDER);

                        ///Temporary
                        /*console.log(this.tempCardArr[i].CREDIT_USED, Records[x].AMOUNT_TENDER)
                        let abc = (this.tempCardArr[i].CREDIT_USED).toFixed(2);
                        console.log(abc)
                        //let def = (Records[x].AMOUNT_TENDER).toString();
                        //console.log(def.toFixed(2))
                        let def = (parseFloat(Records[x].AMOUNT_TENDER)).toFixed(2);
                        console.log(def)
                        let z = parseFloat(abc) + parseFloat(def);
                        console.log(z);
                        this.tempCardArr[i].CREDIT_USED = parseFloat(z.toFixed(2));*/
                        //
                        //MOI - GET SO TAX
                        /*let tbl = ["SO"];
                        let column = ["SO_ID"];
                        let value = [Records[x].SO_ID];
                        
                        let tblkey = ["No"];
                        let fktbl = ["No"];
                        let fkkey = ["No"];
                    
                        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                        let mydata = Object.assign(jsonitem);
                        let json_data = this.serviceapi.json_readdata(mydata,"1");
                        console.log(JSON.stringify(json_data));
                        this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
                          this.Status = result["Message"];
                          let SO_Records = result["Records"];
                          if (this.Status == "1"){
                            //console.log
                            this.taxTotal = parseFloat(this.taxTotal) + parseFloat(SO_Records[0].TOTAL_TAX);
                            
                          }
                        }, (err) => {
                          this.errorMessage2 = "Loading Error. Please try again.";
                          this.loading.dismiss();
                         });*/
                         //GET SO TAX
                        console.log(this.tempCardArr[i].CREDIT_USED)
                      }
                      else
                      {
                        console.log("dddd");
                      }
                    }
                    else {
                      this.tempCardArr[i].CREDIT_USED += +Records[x].AMOUNT_TENDER;
                        //MOI - GET SO TAX
                        /*let tbl = ["SO"];
                        let column = ["SO_ID"];
                        let value = [Records[x].SO_ID];
                        
                        let tblkey = ["No"];
                        let fktbl = ["No"];
                        let fkkey = ["No"];
                    
                        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                        let mydata = Object.assign(jsonitem);
                        let json_data = this.serviceapi.json_readdata(mydata,"1");
                        console.log(JSON.stringify(json_data));
                        this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
                          this.Status = result["Message"];
                          let SO_Records = result["Records"];
                          if (this.Status == "1"){
                            //console.log
                            this.taxTotal = parseFloat(this.taxTotal) + parseFloat(SO_Records[0].TOTAL_TAX);
                            
                          }
                        }, (err) => {
                          this.errorMessage2 = "Loading Error. Please try again.";
                          this.loading.dismiss();
                         });*/
                      //MOI - GET SO TAX
                    }
                  }
                  

                  if (this.tempCardArr[i].CREDIT_USED > 0){                                         //save only if credit used more than 0
                    this.cardArr.push(this.tempCardArr[i]);
                    this.subTotal = this.subTotal + this.tempCardArr[i].CREDIT_USED;                 //accumulate 

                    this.invoiceLineData.DATETIME = this.ISSUE_SERVERDATE;
                    this.invoiceLineData.TOTAL_CARD_USED = this.totalCard;
                    this.invoiceLineData.CARD_ID = this.tempCardArr[i].CARD_ID;
                    this.invoiceLineData.USED_CREDIT = this.tempCardArr[i].CREDIT_USED;
                    console.log("2>>"+this.invoiceLineData);
                    this.INVOICELINE_JSON(this.invoiceLineData.TOTAL_CARD_USED, this.invoiceLineData.CARD_ID, this.invoiceLineData.USED_CREDIT);
                  }
                }
                else {
//                  this.errorMessage2 = this.serviceapi.displayErrorMessage(this.Status);
                   
                }
                console.log(i+">>"+rxdata)
                this.taxTotal = (parseFloat(this.subTotal) - (parseFloat(this.subTotal)*100)/110).toString();
                if (i == (rxdata-1)){
                  console.log("test");
                  //this.taxTotal = this.count_tax;//this.tax * this.subTotal;                                 //get tax amount
                  //this.grandTotal = this.subTotal;                         //get grand amount
                  //MOI - Commented to get the value when click issue to avoid slow reply
                  //this.invoiceData.SUB_TOTAL = (parseFloat(this.subTotal)-parseFloat(this.taxTotal)).toString();
                  //this.invoiceData.TAX = this.taxTotal;
                  //this.invoiceData.GRANDTOTAL = this.grandTotal;
                  
                  this.loading.dismiss();
                }
                

                
              }, (err) => {
                this.errorMessage2 = "Loading Error. Please try again.";
                this.loading.dismiss();
              });
              
            }
            

          }
          else {
            this.errorMessage2 = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
            this.errorMessage2 = "Loading Error. Please try again.";
            this.loading.dismiss();
        });
      }
      else {
        //this.errorMessage2 = this.serviceapi.displayErrorMessage(this.Status);
        //this.loading.dismiss();
        //MOI Start
        
         //search corporate card
         let tbl = ["CARD"];
         let column = ["CORP_ID"];
         let value = [this.invoiceData.INV_CORP_ID];
         
         let tblkey = ["No"];
         let fktbl = ["No"];
         let fkkey = ["No"];
 
         let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
         let mydata = Object.assign(jsonitem);
         let json_data = this.serviceapi.json_readdata(mydata,"1");
 
         this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
             
           this.Status = result["Message"];
           if (this.Status == "1"){
             
             let Records = result["Records"];
             let rxdata = result["RXData"];
             this.totalCard = result["RXData"];          //total card under corporate
 
          /*for(let i=0;i<rxdata;i++)
             {
               Records[i].CREDIT_USED = Records[i].CREDIT_LIMIT - Records[i].BALANCE;  //calculate credit used
               this.cardArr.push(Records[i]);
               this.subTotal = this.subTotal + Records[i].CREDIT_USED;                 //accumulate 
 
               this.invoiceLineData.DATETIME = this.SERVERDATE;
               this.invoiceLineData.TOTAL_CARD_USED = rxdata;
               this.invoiceLineData.CARD_ID = Records[i].CARD_ID;
               this.invoiceLineData.USED_CREDIT = Records[i].CREDIT_USED;
               console.log(this.invoiceLineData.USED_CREDIT);
               this.INVOICELINE_JSON(this.invoiceLineData.TOTAL_CARD_USED, this.invoiceLineData.CARD_ID, this.invoiceLineData.USED_CREDIT);
             } */
 
             this.tempCardArr = Records;
             for(let i=0; i<rxdata; i++)
             {
               this.tempCardArr[i].CREDIT_USED = 0;
 
               //find payment record for the card
               let tbl = ["PAYMENT","PAYMENT","SO"];
              let column = ["CORP_CARD_ID","PAYMENT_TYPE_ID","SO_STATUS_ID"];
              let value = [this.tempCardArr[i].CARD_ID, "3", "1"];
              
              let tblkey = ["SO_ID"];
              let fktbl = ["SO"];
              let fkkey = ["SO_ID"];
           
               let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
               //let mydata = Object.assign(jsonitem);
               //let json_data = this.serviceapi.json_readdata(mydata,"1");
 


               //let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
              var date = new Date(this.SERVERDATE+ " 23:59:59");
              date.setDate(date.getDate());
              var y = date.getFullYear(),
              m = date.getMonth() + 1, // january is month 0 in javascript
              d = date.getDate();
              var pad = function(val) { var str = val.toString(); return (str.length < 2) ? "0" + str : str};
              var dateString = [y, pad(m), pad(d)].join("-");
                // Add a day because ended at selected date + 00:00:00 which will get value on the day as well
              //DATA.DATE = dateString;
              let rangeitem = this.serviceapi.range(this.last_invoice_date,dateString,"DATETIME","PAYMENT");
              let mydata = Object.assign(jsonitem,rangeitem);
              let json_data = this.serviceapi.json_readdata_range(mydata,"1");
              console.log("MOI"+json_data);
            
               this.serviceapi.readdata(json_data,"PAYMENT","1","1").then((result) => {
                 this.Status = result["Message"];
                 console.log(result["Records"]);
                 if (this.Status == "1"){
                   
                   let Records = result["Records"];
                   let rxdata1 = result["RXData"];
 
                   console.log("MOI"+this.last_invoice_date)
                   
                   
 
                   for(let x=0; x<rxdata1; x++){
                     //MOI - GET SO TAX
                    /*let tbl = ["SO"];
                    let column = ["SO_ID"];
                    let value = [Records[x].SO_ID];
                    
                    let tblkey = ["No"];
                    let fktbl = ["No"];
                    let fkkey = ["No"];
                
                    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                    let mydata = Object.assign(jsonitem);
                    let json_data = this.serviceapi.json_readdata(mydata,"1");
      
                    this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
                      this.Status = result["Message"];
                      let SO_Records = result["Records"];
                      if (this.Status == "1"){
                        //console.log
                        this.taxTotal = parseFloat(this.taxTotal) + parseFloat(SO_Records[0].TOTAL_TAX);
                        
                      }
                    }, (err) => {
                      this.errorMessage2 = "Loading Error. Please try again.";
                      this.loading.dismiss();
                     });*/

                     //End Tax SO
                    /* if (this.last_invoice_date != '') {
                       console.log(Records[x].DATETIME)
                       if (Records[x].DATETIME > this.last_invoice_date){
                         console.log("Date bigger!!!")
                         console.log(this.tempCardArr[i].CREDIT_USED, Records[x].AMOUNT_TENDER)
                         this.tempCardArr[i].CREDIT_USED += +Records[x].AMOUNT_TENDER;
                         console.log(this.tempCardArr[i].CREDIT_USED)
                       }
                     }
                     else {*/
                       this.tempCardArr[i].CREDIT_USED += +Records[x].AMOUNT_TENDER;
                     //}
                   }
                   console.log(this.tempCardArr[i])
 
                   if (this.tempCardArr[i].CREDIT_USED > 0){                                         //save only if credit used more than 0
                     this.cardArr.push(this.tempCardArr[i]);
                     this.subTotal = this.subTotal + this.tempCardArr[i].CREDIT_USED;                 //accumulate 
 
                     this.invoiceLineData.DATETIME = this.SERVERDATE;
                     this.invoiceLineData.TOTAL_CARD_USED = this.totalCard;
                     this.invoiceLineData.CARD_ID = this.tempCardArr[i].CARD_ID;
                     this.invoiceLineData.USED_CREDIT = this.tempCardArr[i].CREDIT_USED;
                     console.log(this.invoiceLineData);
                     this.INVOICELINE_JSON(this.invoiceLineData.TOTAL_CARD_USED, this.invoiceLineData.CARD_ID, this.invoiceLineData.USED_CREDIT);
                   }
                 }
                 else {
 //                  this.errorMessage2 = this.serviceapi.displayErrorMessage(this.Status);
 
                 }
                 this.taxTotal = (parseFloat(this.subTotal) - (parseFloat(this.subTotal)*100)/110).toString();
                 if (i == (rxdata-1)){
                   console.log(this.subTotal);
                   
                   //this.taxTotal = this.count_tax;//this.tax * this.subTotal;                        //get tax amount
                   //this.grandTotal = this.taxTotal +  this.subTotal;                         //get grand amount
                    //MOI - Commented to get the value when click issue to avoid slow reply
                   //this.invoiceData.SUB_TOTAL = (parseFloat(this.subTotal)-parseFloat(this.taxTotal)).toString();
                   //this.invoiceData.TAX = this.taxTotal;
                   //this.invoiceData.GRANDTOTAL = this.grandTotal;
                   
                   this.loading.dismiss();
                 }
                 
 
                 
               }, (err) => {
                 this.errorMessage2 = "Loading Error. Please try again.";
                 this.loading.dismiss();
               });
               
             }
             
 
           }
           else {
             this.errorMessage2 = this.serviceapi.displayErrorMessage(this.Status);
             this.loading.dismiss();
           }
         }, (err) => {
             this.errorMessage2 = "Loading Error. Please try again.";
             this.loading.dismiss();
         });



        //--
      }

    }, (err) => {
      this.errorMessage2 = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

    
  }

/*   printInvoice(){
    
    this.serviceapi.printDocument('2','2').then((result) => {
      let Records = result["Records"];
      window.open(Records, '', 'height=400,width=600');
    });

  } */

  saveDraft(){
    if (this.invoiceData.INV_CORP_ID == '') {
      this.errorMessage2 = 'Please select corporate.';
    }
    else {
      this.invoiceData.FINALIZED_FLG = 'Draft';
      this.addInvoice(0);
    }
    
  }

  issue(){
    //MOI - Assigned to invoiceData
    this.invoiceData.SUB_TOTAL = (parseFloat(this.subTotal)-parseFloat(this.taxTotal)).toString();
    this.invoiceData.TAX = this.taxTotal;
    this.invoiceData.GRANDTOTAL = this.subTotal;
    console.log("WTF"+this.grandTotal);
    if (this.invoiceData.INV_CORP_ID == '') {
      this.errorMessage2 = 'Please select corporate.';
    }
    else {
      this.invoiceData.FINALIZED_FLG = 'Draft';
      this.addInvoice(1);
    }
  }

  addInvoice(VIEW){
    if(parseInt(this.invoiceData.GRANDTOTAL) != 0)
    {
      this.showLoader();
      this.DATA_JSON(this.USER_ID, this.invoiceData.GRANDTOTAL, (parseFloat(this.invoiceData.GRANDTOTAL)-parseFloat(this.taxTotal)).toString(), parseFloat(this.taxTotal), 
                    this.invoiceData.FINALIZED_FLG, this.invoiceData.INV_CORP_ID, this.invoiceData.REMARKS, this.INV_LINE_Array);

      let value = this.SUBMIT_JSON(this.USER_ID,this.DATA_Array);
      console.log(JSON.stringify(value));
      this.serviceapi.invociedata(value).then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        let Last_ID = result["Invoice_ID"];
        if (this.Status == '1'){
          
          if (VIEW == 1){
            this.serviceapi.printDocument('2',Last_ID,"1").then((result) => {     //view report
              let Records = result["Records"];
              window.open(Records, '', 'height=400,width=600');
            });
          }
          
          this.navCtrl.setRoot(B07InvoicePage);
        }
        else {
          this.errorMessage3 = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage3 = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    }
    else
    {
      this.errorMessage3 = "No Transaction Found";
    }
  }

  INVOICELINE_JSON(TOTAL_CARD_USED, CARD_ID, USED_CREDIT)
  {
      let INV_LINE = {	

        TOTAL_CARD_USED:"",
        CARD_ID:"",
        USED_CREDIT:0,     
      }
      
      INV_LINE.TOTAL_CARD_USED = TOTAL_CARD_USED;
      INV_LINE.CARD_ID = CARD_ID;
      INV_LINE.USED_CREDIT = USED_CREDIT;

      this.INV_LINE_Array.push(INV_LINE)
      
  }

  DATA_JSON(ACTION_BY, GRANDTOTAL, SUB_TOTAL, TAX, FINALIZED_FLG, INV_CORP_ID, REMARKS, INVOICE_LINE)
  {
      let DATA = {
				INVOICE_TOTAL:0,
        ACTION_BY:"",
        SUB_TOTAL:"",
        TAX:"",
        DATE:"",
				GRANDTOTAL:"",
				FINALIZED_FLG:"",
				INV_CORP_ID:"",
				REMARKS:"",
				INVOICE_LINE:[]
      }
 
      DATA.INVOICE_TOTAL = (this.INV_LINE_Array).length;
      DATA.ACTION_BY = ACTION_BY;
      DATA.SUB_TOTAL = SUB_TOTAL;
      DATA.TAX = TAX;
      var date = new Date(this.SERVERDATE);
      date.setDate(date.getDate());
      var y = date.getFullYear(),
      m = date.getMonth() + 1, // january is month 0 in javascript
      d = date.getDate();
      var pad = function(val) { var str = val.toString(); return (str.length < 2) ? "0" + str : str};
      var dateString = [y, pad(m), pad(d)].join("-");
        // Add a day because ended at selected date + 00:00:00 which will get value on the day as well
      DATA.DATE = dateString;
      DATA.GRANDTOTAL = GRANDTOTAL;
      DATA.FINALIZED_FLG = FINALIZED_FLG;
      DATA.INV_CORP_ID = INV_CORP_ID;
      DATA.REMARKS = REMARKS;
      DATA.INVOICE_LINE = INVOICE_LINE;

      this.DATA_Array.push(DATA);
  }

  SUBMIT_JSON(USERID,DATA)
  {
      let COMPILE_DATA = {
				Param:"",
				UserID:"",
				Total:0,
				Data:[]
      }
      COMPILE_DATA.Param = "1";
      COMPILE_DATA.UserID = USERID;
      COMPILE_DATA.Total =  (this.DATA_Array).length;
      COMPILE_DATA.Data = DATA;

     return COMPILE_DATA;
  }

  cancel(){
    //this.navCtrl.pop();
    this.navCtrl.setRoot(B07InvoicePage);
    //Change by Moi
  }

  goTo(){
    this.navCtrl.setRoot(B07InvoicePage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b07b-invoice-add/b07b-invoice-add.ts